<template>
  <div
    v-if="src && src.length"
    class="sb-illustration"
    :style="{
      maxWidth: width,
    }"
  >
    <img class="sb-illustration__image" :src="src" :alt="alt" />
    <slot />
  </div>
</template>

<script lang="ts" setup>
export type SbIllustrationProps = {
  src?: string
  alt?: string
  width?: string
}

withDefaults(defineProps<SbIllustrationProps>(), {
  width: '120px',
})
</script>
